export const TAG_MAX_LEN = 24;
export const TAG_MAX_COUNT = 10;

/**
 * Normalizes user-supplied tags for the editor (trim, lowercase, collapse
 * whitespace, cap length, drop empties, dedupe, cap count). Mirrors the
 * authoritative server rule in supabase/functions/_shared/tags.ts so a tag set
 * shown in the UI matches what the server stores.
 */
export function sanitizeTags(raw: readonly string[]): string[] {
  const out: string[] = [];
  const seen = new Set<string>();
  for (const entry of raw) {
    const tag = entry.trim().toLowerCase().replace(/\s+/g, " ").slice(0, TAG_MAX_LEN);
    if (tag === "" || seen.has(tag)) {
      continue;
    }
    seen.add(tag);
    out.push(tag);
    if (out.length >= TAG_MAX_COUNT) {
      break;
    }
  }
  return out;
}
